"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AdPlacementKey = void 0;
const AdPlacementKey_1 = require("../AdPlacementKey");
class AdAnalyticsPlacement {
    constructor({ key, name }) {
        this.toJSON = () => ({
            key: this.key,
            name: this.name,
        });
        this.key = key;
        this.name = name;
    }
}
AdAnalyticsPlacement.fromJSON = (json) => {
    const { key, name } = Object.assign({}, json);
    if (typeof name !== 'string')
        throw new Error('.name must be a string');
    const _key = deserializeToAdAnalyticsPlacement(key);
    return new AdAnalyticsPlacement({
        key: _key,
        name: name,
    });
};
const deserializeToAdAnalyticsPlacement = (str) => {
    if (Object.keys(exports.AdPlacementKey).indexOf(str) === -1) {
        throw new Error(`str must be a one of ${Object.keys(exports.AdPlacementKey).join(', ')}`);
    }
    return str;
};
exports.AdPlacementKey = {
    all_placements: 'all_placements',
    an_classic: 'an_classic',
    feed: 'feed',
    instant_article: 'instant_article',
    instream_video: 'instream_video',
    facebook_stories: 'facebook_stories',
    facebook_feed: 'facebook_feed',
    instagram_explore: 'instagram_explore',
    instagram_stories: 'instagram_stories',
    instagram_feed: 'instagram_feed',
    native_banner_interstitial: 'native_banner_interstitial',
    rewarded_video: 'rewarded_video',
    content: 'content',
    marketplace: 'marketplace',
    mixed: 'mixed',
    search: 'search',
    search_partners: 'search_partners',
    unknown: 'unknown',
    unspecified: 'unspecified',
    youtube_search: 'youtube_search',
    youtube_watch: 'youtube_watch',
    messenger_inbox: 'messenger_inbox',
    messenger_stories: 'messenger_stories',
    right_hand_column: 'right_hand_column',
    sponsored_messages: 'sponsored_messages',
    suggested_video: 'suggested_video',
    facebook_instant_article: 'facebook_instant_article',
    facebook_instream_video: 'facebook_instream_video',
    facebook_marketplace: 'facebook_marketplace',
    facebook_suggested_video: 'facebook_suggested_video',
    facebook_playable_ads: 'facebook_playable_ads',
    facebook_playable_game_demo: 'facebook_playable_game_demo',
    instagram_right_hand_column: 'instagram_right_hand_column',
    audience_network_native_banner_interstitial: 'audience_network_native_banner_interstitial',
    audience_network_rewarded_video: 'audience_network_rewarded_video',
    audience_network_an_classic: 'audience_network_an_classic',
    audience_network_all_placements: 'audience_network_all_placements',
    audience_network_instream_video: 'audience_network_instream_video',
    messenger_sponsored_messages: 'messenger_sponsored_messages',
    google_content: 'google_content',
    google_mixed: 'google_mixed',
    google_search: 'google_search',
    google_search_partners: 'google_search_partners',
    google_unknown: 'google_unknown',
    google_unspecified: 'google_unspecified',
    google_any_placement: 'google_any_placement',
    static_image_placement: 'static_image_placement',
    youtube_trueview: 'youtube_trueview',
    youtube_non_skippable_video_ads: 'youtube_non_skippable_video_ads',
    youtube_bumper_ads: 'youtube_bumper_ads',
    youtube_skippable_video_ads: 'youtube_skippable_video_ads',
};
exports.default = AdAnalyticsPlacement;
